module.exports = __webpack_public_path__ + "img/ssclick-est-can-cola-upside-down.40652dbb.png";